import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ArrowRight } from 'lucide-react';
import type { AdTemplate } from '@shared/schema';
import { selectInspirationCards } from './inspiration-cards';
import { useCanvasStore } from './canvas-store';

/** A short optional sampler. The existing library retains every style, filter,
 * reference and clone action, rather than repeating the library on Create. */
export function DiscoverSections({ onUseTemplate }: {onUseTemplate: (style: string) => void}) {
  const { data: templates = [] } = useQuery<AdTemplate[]>({ queryKey: ['/api/ad-templates'] });
  const openAdLibrary = useCanvasStore(s => s.openAdLibrary);
  const samples = useMemo(() => selectInspirationCards(templates), [templates]);
  if (!samples.length) return null;
  return (
    <section className="adoption-inspiration" aria-labelledby="inspiration-title">
      <div className="adoption-inspiration-header">
        <div>
          <h2 id="inspiration-title">A little inspiration.</h2>
          <p>Choose a template to fill your brief. Edit it, then generate.</p>
        </div>
        <button type="button" className="adoption-text-link" onClick={() => openAdLibrary([])}>
          Browse all inspiration <ArrowRight size={14} style={{ display: 'inline', marginLeft: 4 }} aria-hidden="true" />
        </button>
      </div>
      <div className="adoption-inspiration-grid">
        {samples.map(({ style, template }) => (
          <button key={template.id} type="button" className="adoption-discover-card" data-testid={`discover-card-${template.id}`}
            aria-label={`Use ${style} template`} onClick={() => onUseTemplate(style)}>
            <img src={template.imageUrl} alt={template.name} loading="lazy"
              className={style === 'Education' || style === 'How It Works' ? 'adoption-discover-image-inset' : undefined} />
            <span className="adoption-discover-caption">{style} <ArrowRight size={15} aria-hidden="true" /></span>
          </button>
        ))}
      </div>
    </section>
  );
}
